import { Pagination, styled } from "@mui/material";
import { fontWeight } from "@mui/system";
import React, { useEffect } from "react";
interface MxPaginationProps {
  page: number;
  totalPages: number;
  onChangePage?: (page: number) => void;
}
const MxPagination = (props: MxPaginationProps) => {
  const [page, setPage] = React.useState(1);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
    props.onChangePage && props.onChangePage(value);
  };

  useEffect(() => {
    if (props.page === page) return;
    setPage(props.page);
  }, [props.page]);

  return (
    <CustomPagination page={page} count={props.totalPages} onChange={handleChange} />
  );
};

export default MxPagination;

const CustomPagination = styled(Pagination)(({ theme }) => ({
  display: "flex",
  width: "100%",
  justifyContent: "center",

  "& .MuiPagination-ul": {
    backgroundColor: "white",
    borderRadius: 100,
    padding: 5,
    "* ": {
      fontSize: 12,
      fontWeight: 500
    }
  }
}));
